// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"68a726e8","787":"5b557567","867":"6c13d362"}[chunkId] + ".chunk.js";
};